import script from "./PictureCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PictureCom.vue?vue&type=script&setup=true&lang=js"

import "./PictureCom.vue?vue&type=style&index=0&id=64b81710&scoped=true&lang=css"
import "./PictureCom.vue?vue&type=style&index=1&id=64b81710&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b81710"]])

export default __exports__